export function getInstance () {
  if (!window.opener) {
    return window.DGNCheckout
  } else {
    return window.opener.DGNCheckout
  }
}
